import React from "react";
import { useFormik } from "formik";
import Input from "components/input";
import DatePicker from "components/datePicker";
import Separator from "components/separator";
import Select from "components/select";
import { Row, Col } from "react-bootstrap";
import Button from "components/button";
import provinces from "lib/provinces";
import validator from "validator";
import { genderOptions } from "constants/gender";
import { plateOptions } from "constants/plate";
const validate = (values) => {
  const errors = {};
  if (!values.first_name) {
    errors.first_name = "اجباری است";
  }
  if (!values.last_name) {
    errors.last_name = "اجباری است";
  }
  if (!values.father_name) {
    errors.father_name = "اجباری است";
  }
  if (!values.id_number) {
    errors.id_number = "اجباری است";
  }
  if (values.id_number && !validator.isNumeric(values.id_number)) {
    errors.id_number = "شماره شناسنامه باید عدد باشد";
  }
  if (!values.id_number_series) {
    errors.id_number_series = "اجباری است";
  }
  if (!values.gender) {
    errors.gender = "اجباری است";
  }
  if (!values.birthday) {
    errors.birthday = "اجباری است";
  }
  if (!values.id_number_creation_date) {
    errors.id_number_creation_date = "اجباری است";
  }
  if (!values.id_number_province) {
    errors.id_number_province = "اجباری است";
  }
  if (!values.id_number_city) {
    errors.id_number_city = "اجباری است";
  }
  if (!values.birthday_province) {
    errors.birthday_province = "اجباری است";
  }
  if (!values.birthday_city) {
    errors.birthday_city = "اجباری است";
  }
  if (!values.type_of_plate) {
    errors.type_of_plate = "اجباری است";
  }

  if (!values.address_province) {
    errors.address_province = "اجباری است";
  }
  if (!values.address_city) {
    errors.address_city = "اجباری است";
  }
  if (!values.address_primary_street) {
    errors.address_primary_street = "اجباری است";
  }
  if (!values.address_secondary_street) {
    errors.address_secondary_street = "اجباری است";
  }
  if (!values.address_alley) {
    errors.address_alley = "اجباری است";
  }
  if (!values.address_no) {
    errors.address_no = "اجباری است";
  }
  if (!values.address_postal_code) {
    errors.address_postal_code = "اجباری است";
  }
  if (
    values.address_postal_code &&
    !validator.isNumeric(values.address_postal_code)
  ) {
    errors.address_postal_code = "کد پستی باید عدد باشد";
  }
  if (!values.bank_sheba) {
    errors.bank_sheba = "اجباری است";
  }
  if (!values.bank_name) {
    errors.bank_name = "اجباری است";
  }
  if (!values.contact_phone) {
    errors.contact_phone = "اجباری است";
  }
  if (values.contact_phone && !validator.isNumeric(values.contact_phone)) {
    errors.contact_phone = "فقط عدد وارد کنید";
  }
  if (values.contact_email && !validator.isEmail(values.contact_email)) {
    errors.contact_email = "ایمیل صحیح نیست";
  }
  return errors;
};
const IndividualForm = ({ onChange, loading, information }) => {
  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      father_name: "",
      id_number: "",
      id_number_series: "",
      gender: "",
      birthday: "",
      id_number_creation_date: "",
      id_number_province: "",
      id_number_city: "",
      birthday_province: "",
      birthday_city: "",
      type_of_plate: "",
      address_province: "",
      address_city: "",
      address_primary_street: "",
      address_secondary_street: "",
      address_alley: "",
      address_no: "",
      address_postal_code: "",
      bank_sheba: "",
      bank_name: "",
      bank_national_code: "",
      contact_phone: "",
      contact_email: "",
      ...information,
    },
    validate,
    onSubmit: (values) => {
      onChange(values);
    },
    validateOnChange: false,
  });
  const getCities = (id) => {
    let result = [];
    for (let i = 0; i < provinces.length; i++) {
      if (provinces[i].id === Number(id)) {
        result = provinces[i].cities;
        break;
      }
    }
    return result;
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <Separator title="اطلاعات شخصی" />
      <Row>
        <Col sm={12} md={3}>
          <div className="form-item">
            <Input
              name="first_name"
              onChange={formik.handleChange}
              value={formik.values.first_name}
              label="نام:"
              error={formik.errors.first_name}
              required
            />
          </div>
        </Col>
        <Col sm={12} md={3}>
          <div className="form-item">
            <Input
              name="last_name"
              onChange={formik.handleChange}
              value={formik.values.last_name}
              label="نام خانوادگی:"
              error={formik.errors.last_name}
              required
            />
          </div>
        </Col>
        <Col sm={12} md={3}>
          <div className="form-item">
            <Input
              name="father_name"
              onChange={formik.handleChange}
              value={formik.values.father_name}
              label="نام پدر:"
              error={formik.errors.father_name}
              required
            />
          </div>
        </Col>
        <Col sm={12} md={3}>
          <div className="form-item">
            <Input
              name="id_number"
              type="number"
              ltr
              onChange={formik.handleChange}
              value={formik.values.id_number}
              label="شماره شناسنامه:"
              error={formik.errors.id_number}
              required
            />
          </div>
        </Col>
        <Col sm={12} md={3}>
          <div className="form-item">
            <Input
              name="id_number_series"
              type="number"
              ltr
              onChange={formik.handleChange}
              value={formik.values.id_number_series}
              label="سریال شناسنامه: (فقط قسمت عددی)"
              error={formik.errors.id_number_series}
              required
            />
          </div>
        </Col>
        <Col sm={12} md={3}>
          <div className="form-item">
            <Select
              name="gender"
              onChange={formik.handleChange}
              value={formik.values.gender}
              options={genderOptions}
              label="جنسیت:"
              error={formik.errors.gender}
              required
            />
          </div>
        </Col>
        <Col sm={12} md={3}>
          <div className="form-item">
            <DatePicker
              name="birthday"
              onChange={formik.handleChange}
              value={formik.values.birthday}
              label="تاریخ تولد:"
              error={formik.errors.birthday}
              required
            />
          </div>
        </Col>
        <Col sm={12} md={3}>
          <div className="form-item">
            <DatePicker
              name="id_number_creation_date"
              onChange={formik.handleChange}
              value={formik.values.id_number_creation_date}
              label="تاریخ صدور شناسنامه:"
              error={formik.errors.id_number_creation_date}
              required
            />
          </div>
        </Col>
        <Col sm={12} md={3}>
          <div className="form-item">
            <Select
              name="id_number_province"
              onChange={(e) => {
                formik.handleChange(e);
                formik.setFieldValue("id_number_city", "", false);
              }}
              value={formik.values.id_number_province}
              options={provinces}
              label="استان صدور شناسنامه:"
              error={formik.errors.id_number_province}
              required
            />
          </div>
        </Col>
        <Col sm={12} md={3}>
          <div className="form-item">
            <Select
              name="id_number_city"
              onChange={formik.handleChange}
              value={formik.values.id_number_city}
              options={getCities(formik.values.id_number_province)}
              label="شهر صدور شناسنامه:"
              error={formik.errors.id_number_city}
              required
            />
          </div>
        </Col>
        <Col sm={12} md={3}>
          <div className="form-item">
            <Select
              name="birthday_province"
              onChange={(e) => {
                formik.handleChange(e);
                formik.setFieldValue("birthday_city", "", false);
              }}
              value={formik.values.birthday_province}
              options={provinces}
              label="استان تولد:"
              error={formik.errors.birthday_province}
              required
            />
          </div>
        </Col>
        <Col sm={12} md={3}>
          <div className="form-item">
            <Select
              name="birthday_city"
              onChange={formik.handleChange}
              value={formik.values.birthday_city}
              options={getCities(formik.values.birthday_province)}
              label="شهر محل تولد:"
              error={formik.errors.birthday_city}
              required
            />
          </div>
        </Col>

        <Col sm={12} md={3}>
          <div className="form-item">
            <Select
              name="type_of_plate"
              onChange={formik.handleChange}
              value={formik.values.type_of_plate}
              options={plateOptions}
              label="نوع پلاک درخواستی:"
              error={formik.errors.type_of_plate}
              required
            />
          </div>
        </Col>
      </Row>
      <Separator title="آدرس" />
      <Row>
        <Col sm={12} md={3}>
          <div className="form-item">
            <Select
              name="address_province"
              onChange={(e) => {
                formik.handleChange(e);
                formik.setFieldValue("address_city", "", false);
              }}
              value={formik.values.address_province}
              options={provinces}
              label="استان:"
              error={formik.errors.address_province}
              required
            />
          </div>
        </Col>
        <Col sm={12} md={3}>
          <div className="form-item">
            <Select
              name="address_city"
              onChange={formik.handleChange}
              value={formik.values.address_city}
              options={getCities(formik.values.address_province)}
              label="شهر:"
              error={formik.errors.address_city}
              required
            />
          </div>
        </Col>
        <Col sm={12} md={3}>
          <div className="form-item">
            <Input
              name="address_primary_street"
              onChange={formik.handleChange}
              value={formik.values.address_primary_street}
              label="خیابان اصلی:"
              error={formik.errors.address_primary_street}
              required
            />
          </div>
        </Col>
        <Col sm={12} md={3}>
          <div className="form-item">
            <Input
              name="address_secondary_street"
              onChange={formik.handleChange}
              value={formik.values.address_secondary_street}
              label="خیابان فرعی:"
              error={formik.errors.address_secondary_street}
              required
            />
          </div>
        </Col>
        <Col sm={12} md={4}>
          <div className="form-item">
            <Input
              name="address_alley"
              onChange={formik.handleChange}
              value={formik.values.address_alley}
              label="کوچه:"
              error={formik.errors.address_alley}
              required
            />
          </div>
        </Col>
        <Col sm={12} md={4}>
          <div className="form-item">
            <Input
              name="address_no"
              type="number"
              ltr
              onChange={formik.handleChange}
              value={formik.values.address_no}
              label="پلاک:"
              error={formik.errors.address_no}
              required
            />
          </div>
        </Col>
        <Col sm={12} md={4}>
          <div className="form-item">
            <Input
              name="address_postal_code"
              type="number"
              ltr
              onChange={formik.handleChange}
              value={formik.values.address_postal_code}
              label="کد پستی:"
              error={formik.errors.address_postal_code}
              required
            />
          </div>
        </Col>
      </Row>
      <Separator title="اطلاعات بانکی" />
      <Row>
        <Col sm={12} md={6}>
          <div className="form-item">
            <Input
              name="bank_sheba"
              type="number"
              ltr
              onChange={formik.handleChange}
              value={formik.values.bank_sheba}
              label="شماره شبا:"
              error={formik.errors.bank_sheba}
              icon={<div className="icon">IR</div>}
              required
            />
          </div>
        </Col>
        <Col sm={12} md={6}>
          <div className="form-item">
            <Input
              name="bank_name"
              onChange={formik.handleChange}
              value={formik.values.bank_name}
              label="نام بانک:"
              error={formik.errors.bank_name}
              required
            />
          </div>
        </Col>

        <Col sm={12}>
          <div className="form-item">
            <Input
                name="bank_national_code"
                onChange={formik.handleChange}
                value={formik.values.bank_national_code}
                label="کد:"
                error={formik.errors.bank_national_code}
                required
            />
          </div>
        </Col>
      </Row>
      <Separator title="اطلاعات تماس" />
      <Row>
        <Col sm={12} md={6}>
          <div className="form-item">
            <Input
              name="contact_phone"
              onChange={formik.handleChange}
              value={formik.values.contact_phone}
              label="شماره ثابت:"
              type="number"
              ltr
              error={formik.errors.contact_phone}
              required
            />
          </div>
        </Col>
        <Col sm={12} md={6}>
          <div className="form-item">
            <Input
              name="contact_email"
              onChange={formik.handleChange}
              value={formik.values.contact_email}
              type="email"
              ltr
              label="ایمیل:"
              error={formik.errors.contact_email}
            />
          </div>
        </Col>
      </Row>
      <div className="buttons">
        <Button title="ثبت اطلاعات" type="submit" loading={loading} />
      </div>
    </form>
  );
};
export default IndividualForm;
